const CONSTANTS = {
  SERVER_URI: "https://api-hkung.herokuapp.com",
  SEARCH_TYPES: {
    TEAM: "Team",
    PLAYER: "Player"
  }
};

export default CONSTANTS;
